import React from 'react';

const Loading = props => (
  <div
    style={{
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      margin: '0',
      padding: '0',
      position: 'fixed',
      backgroundColor: 'black',
      opacity: '0.5',
      zIndex: '2000',
    }}
  >
    <div style={{ position: 'absolute', color: 'White', top: '48%', left: '48%' }}>
      <div className="spinner-border m-auto" style={{ width: '2rem', height: '2rem' }} role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  </div>
);

export default Loading;
